__webpack_require__.p = "/message-in-a-bubble/";